import React, { useState, useEffect, useMemo  } from 'react';
/* global axios */
import api from '../services/apiService';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';  // Import von React Helmet
import Select from 'react-select';

const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);  // Zustand für die Mitarbeiterliste
  const [loading, setLoading] = useState(true);      // Zustand für den Ladeindikator
  const [error, setError] = useState(null);          // Zustand für Fehler


  const [filters, setFilters] = useState(() => {
    const storedFilters = localStorage.getItem('employeeListFilters');
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
          firstName: null,
          lastName: null,
          role: null,
          status: null,
          licenseClasses: null, // Neuer Filter für Führerscheinklassen
        };
  });
  

useEffect(() => {
  localStorage.setItem('employeeListFilters', JSON.stringify(filters));
}, [filters]);







  // Abrufen der Mitarbeiter beim Laden der Seite
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await api.get('/employees');
        setEmployees(response.data);
        setLoading(false);
      } catch (err) {
        setError('Fehler beim Abrufen der Mitarbeiter');
        setLoading(false);
      }
    };

    fetchEmployees();
  }, []);

  const optionsFirstName = useMemo(() => {
    const values = Array.from(new Set(employees.map(emp => emp.firstName).filter(Boolean)));
    return values.map(val => ({ value: val, label: val }));
  }, [employees]);
  
  const optionsLastName = useMemo(() => {
    const values = Array.from(new Set(employees.map(emp => emp.lastName).filter(Boolean)));
    return values.map(val => ({ value: val, label: val }));
  }, [employees]);
  
  const optionsRole = useMemo(() => {
    const values = Array.from(new Set(employees.map(emp => emp.role).filter(Boolean)));
    return values.map(val => ({ value: val, label: val }));
  }, [employees]);
  
  const optionsStatus = useMemo(() => {
    const values = Array.from(new Set(employees.map(emp => emp.status).filter(Boolean)));
    return values.map(val => ({ value: val, label: val }));
  }, [employees]);

  const optionsLicenseClasses = useMemo(() => {
    const allClasses = employees.reduce((acc, emp) => {
      if (emp.licenseClasses && Array.isArray(emp.licenseClasses)) {
        acc.push(...emp.licenseClasses);
      }
      return acc;
    }, []);
    const uniqueClasses = Array.from(new Set(allClasses));
    return uniqueClasses.map(cls => ({ value: cls, label: cls }));
  }, [employees]);
  


  const filteredEmployees = useMemo(() => {
    return employees.filter(emp => {
      const firstName = (emp.firstName || '').toLowerCase();
      const lastName = (emp.lastName || '').toLowerCase();
      const role = (emp.role || '').toLowerCase();
      const status = (emp.status || '').toLowerCase();
      
      return (
        (filters.firstName ? firstName === filters.firstName.value.toLowerCase() : true) &&
        (filters.lastName ? lastName === filters.lastName.value.toLowerCase() : true) &&
        (filters.role ? role === filters.role.value.toLowerCase() : true) &&
        (filters.status ? status === filters.status.value.toLowerCase() : true) &&
        (filters.licenseClasses
          ? (emp.licenseClasses && emp.licenseClasses.includes(filters.licenseClasses.value))
          : true)
      );
    });
  }, [employees, filters]);
  
  
  


  if (loading) {
    return <div>Lade Mitarbeiter...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (employees.length === 0) {
    return <div>Keine Mitarbeiter gefunden.</div>;
  }

  return (
    <div>
      <h2>Mitarbeiterliste</h2>
      <Helmet>
        <title>Mitarbeiterliste</title>
        <meta name="description" content="Mitarbeiterliste" />
      </Helmet>

      {/* Filterzeile oberhalb der Tabelle */}
<div style={{ marginBottom: '20px' }}>
  <h3>Filter</h3>
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px' }}>
    <Select
      options={optionsFirstName}
      placeholder="Vorname"
      isClearable
      value={filters.firstName}
      onChange={(selected) => setFilters({ ...filters, firstName: selected })}
    />
    <Select
      options={optionsLastName}
      placeholder="Nachname"
      isClearable
      value={filters.lastName}
      onChange={(selected) => setFilters({ ...filters, lastName: selected })}
    />
    <Select
      options={optionsRole}
      placeholder="Rolle"
      isClearable
      value={filters.role}
      onChange={(selected) => setFilters({ ...filters, role: selected })}
    />
    <Select
      options={optionsStatus}
      placeholder="Status"
      isClearable
      value={filters.status}
      onChange={(selected) => setFilters({ ...filters, status: selected })}
    />
    <Select
      options={optionsLicenseClasses}
      placeholder="Führerscheinklassen"
      isClearable
      value={filters.licenseClasses}
      onChange={(selected) => setFilters({ ...filters, licenseClasses: selected })}
    />
  </div>
</div>





      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Vorname</th>
            <th>Nachname</th>
            <th>Rolle</th>
            <th>Sortierung</th>
            <th>Telefon</th>
            <th>E-Mail</th>
            <th>Status</th>
            <th>Führerscheinklassen</th>
            <th>Erfahrung (Jahre)</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
        {filteredEmployees.map((emp) => (
            <tr key={emp.id}>
              <td>{emp.id}</td>
              <td>{emp.firstName}</td>
              <td>{emp.lastName}</td>
              <td>{emp.role}</td>
              <td>{emp.sortOrder}</td>
              <td>{emp.phoneNumber}</td>
              <td>{emp.email}</td>
              <td>{emp.status}</td>
              <td>{emp.licenseClasses ? emp.licenseClasses.join(', ') : '-'}</td>
              <td>{emp.yearsOfExperience}</td>
              <td>
                <Link to={`/employeeform/${emp.id}`}>Bearbeiten</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
      <Link to="/employeeform/new">Neuen Mitarbeiter anlegen</Link>
    </div>
  );
};

export default EmployeeList;
